async function fetchPosts() {
  try {
    const res = await fetch(
      "https://graph.facebook.com/v19.0/17841412156472710?fields=username%2Cmedia%7Bcomments_count%2Clike_count%2Cthumbnail_url%2Ccaption%2Cmedia_url%2Cpermalink%2Ccomments%7D&access_token=EAAESLvZC9ApgBO9iDJcNGGA9mnO7WZCtZALL16ZC1vXoJZAmhbWWVE3hqpf3hx0qZB8lCdrFwKQf4FE19xfd8pFZAiui8gXUqxUS7msZAcqHeR64rG25ZCqLwdlaJZCgB2LcBcZCIYNV2TlO4gtN4ZCQcyqp8O52UeE8kZCFGIQexiL66qKIWpnWvGEyQ7UqtOng4IOfjt5tMyrzZA"
    );

    if (!res.ok) {
      throw new Error("Could not fetch resource");
    }

    const data = await res.json();
    const posts = data.media.data;
    const screenWidth = window.innerWidth;
    const postNo = screenWidth > 992 ? 10 : 9;
    // console.log(posts);

    const gridLayout = document.getElementById("grid-layout");

    for (let i = 0; i < postNo && i < posts.length; i++) {
      const post = posts[i];

      const postContainer = document.createElement("div");
      postContainer.classList.add("post-box");

      if (post.thumbnail_url) {
        const imageElement = document.createElement("img");
        const hoverElement = document.createElement("div");
        const likesCountElement = document.createElement("div");
        const likesCountContainer = document.createElement("div");
        const likeIcon = document.createElement("img");
        const commentsCountElement = document.createElement("div");
        const commentsCountContainer = document.createElement("div");
        const commentIcon = document.createElement("img");
        

        likesCountElement.textContent = `${post.like_count}`;
        commentsCountElement.textContent = `${post.comments_count}`;

        hoverElement.classList.add("hoverContent");
        likesCountContainer.classList.add("likesCountdiv");
        likesCountElement.classList.add("likesCountContainer");
        commentsCountElement.classList.add("likesCountContainer");
        commentsCountContainer.classList.add("likesCountdiv");
        likeIcon.classList.add("icon");
        commentIcon.classList.add("icon");
        imageElement.classList.add("post");
        imageElement.src = post.thumbnail_url;
        likeIcon.src = "https://cdn.shopify.com/s/files/1/0513/8251/7915/files/heart.png?v=1713851960";
        commentIcon.src = "https://cdn.shopify.com/s/files/1/0513/8251/7915/files/comments.png?v=1713851956";
        likeIcon.loading='lazy'
        commentIcon.loading="lazy"
        likeIcon.alt ='like icon'
        commentIcon.alt ='comment icon'
        imageElement.alt = ("IG-POST")
        imageElement.width= 500
        imageElement.height=500
        imageElement.loading="lazy"

        hoverElement.appendChild(likesCountContainer);
        hoverElement.appendChild(commentsCountContainer);

        commentsCountContainer.appendChild(commentIcon);
        commentsCountContainer.appendChild(commentsCountElement);

        likesCountContainer.appendChild(likeIcon);
        likesCountContainer.appendChild(likesCountElement);
        postContainer.appendChild(hoverElement);
        postContainer.appendChild(imageElement);
        gridLayout.appendChild(postContainer);

      } else {
        const imageElement = document.createElement("img");
        const hoverElement = document.createElement("div");
        const likesCountElement = document.createElement("div");
        const likesCountContainer = document.createElement("div");
        const likeIcon = document.createElement("img");
        const commentsCountElement = document.createElement("div");
        const commentsCountContainer = document.createElement("div");
        const commentIcon = document.createElement("img");

        likesCountElement.textContent = `${post.like_count}`;
        commentsCountElement.textContent = `${post.comments_count}`;

        hoverElement.classList.add("hoverContent");
        likesCountContainer.classList.add("likesCountdiv");
        likesCountElement.classList.add("likesCountContainer");
        commentsCountElement.classList.add("likesCountContainer");
        commentsCountContainer.classList.add("likesCountdiv");
        likeIcon.classList.add("icon");
        commentIcon.classList.add("icon");
        imageElement.classList.add("post");
        imageElement.src = post.media_url;
        imageElement.alt = ("IG-POST")
        likeIcon.src = "https://cdn.shopify.com/s/files/1/0513/8251/7915/files/heart.png?v=1713851960";
        commentIcon.src = "https://cdn.shopify.com/s/files/1/0513/8251/7915/files/comments.png?v=1713851956";
        likeIcon.alt ='like icon'
        commentIcon.alt ='comment icon'
        likeIcon.loading='lazy'
        commentIcon.loading="lazy"
        imageElement.width= 500
        imageElement.height=500
        imageElement.loading="lazy"

        hoverElement.appendChild(likesCountContainer);
        hoverElement.appendChild(commentsCountContainer);

        commentsCountContainer.appendChild(commentIcon);
        commentsCountContainer.appendChild(commentsCountElement);

        likesCountContainer.appendChild(likeIcon);
        likesCountContainer.appendChild(likesCountElement);
        postContainer.appendChild(hoverElement);
        postContainer.appendChild(imageElement);
        gridLayout.appendChild(postContainer);
      }

      postContainer.addEventListener("click", () => {
        const newIndex = i; // Index of the clicked post
        const newUrl = `${window.location.pathname}?index=${newIndex}`;
        history.pushState({ index: newIndex }, "", newUrl);
        showModal(newIndex, posts); // Pass the posts variable
      });
    }
  } catch (error) {
    console.log(error);
  }
}

const modalEl = document.querySelector(".modal");
const modalBg = document.querySelector(".modal-bg");

document.addEventListener("DOMContentLoaded", function () {
  fetchPosts();

  // Event listener for closing the modal
  // const modalCloseBtn = document.querySelector(".close-btn");
  // modalCloseBtn.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  // Event listener for popstate event
  window.addEventListener("popstate", handlePopState);
});

modalEl.addEventListener("click", (e) => {
  if (e.target === modalBg) {
    closeModal();
  }
});

function showModal(index, posts) {
  const modalContent = modalEl.querySelector(".modal-post");
  const modalCaption = document.querySelector(".modal-caption");
  const comment = document.querySelector(".modal-comment");
  const numLikes = document.querySelector(".num-likes");
  const numComments = document.querySelector(".num-comments");
  const externalLink = document.querySelector(".external-link-icon");

  const post = posts[index];

  if (post.media_url.includes(".mp4")) {
    modalContent.innerHTML = `<video class="modal-post-video" muted controls poster="${post.thumbnail_url}"><source src="${post.media_url}" type="video/mp4"></video>`;
  } else {
    modalContent.innerHTML = `<img class="modal-post-image" width=500 height=500 alt="IG-POST" src="${post.media_url}" loading="lazy">`;
  }

  modalCaption.textContent = post.caption;
  if (post.comments.data.length > 0 && post.comments.data[0].text) {
    comment.textContent = post.comments.data[0].text;
  } else {
    comment.textContent = ""; // or any default value you want to set
  }

  numLikes.textContent = post.like_count;
  numComments.textContent = post.comments_count;
  externalLink.href = post.permalink;

  modalEl.classList.add("active");
}

// Function to close the modal
function closeModal() {
  const modalEl = document.querySelector(".modal");
  const modalContent = modalEl.querySelector(".modal-post");
  modalEl.classList.remove("active");

  // Remove any existing content
  modalContent.innerHTML = "";

  // Remove index from URL
  const newUrl = window.location.pathname;
  history.replaceState(null, "", newUrl);
}

// Event listener for closing the modal
// const modalCloseBtn = document.querySelector(".close-btn");
// modalCloseBtn.addEventListener("click", closeModal);

// Function to handle the popstate event
function handlePopState(event) {
  const index = event.state ? event.state.index : null;
  if (index !== null) {
    const posts = JSON.parse(sessionStorage.getItem("posts"));
    showModal(index, posts);
  } else {
    closeModal();
  }
}

// Event listener for popstate event
window.addEventListener("popstate", handlePopState);
